import { useState } from 'react';
import { TabsProps } from './contracts';
import { GeneratePage } from '../../../cms/GeneratePage';

export function Tabs({ title, tabs, className }: TabsProps) {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  if (!tabs || tabs.length === 0) {
    return null;
  }

  const activeTab = tabs[activeTabIndex];

  return (
    <div className={`cms-tabs ${className ?? ''}`}>
      {title && <h2 className="cms-tabs__title">{title}</h2>}

      <div className="cms-tabs__header">
        {tabs.map((tab, index) => (
          <button
            key={tab.id}
            type="button"
            className={`cms-tabs__tab ${index === activeTabIndex ? 'cms-tabs__tab--active' : ''}`}
            onClick={() => setActiveTabIndex(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="cms-tabs__content">
        {activeTab && (activeTab.layout || activeTab.children) && (
          <div className="cms-tabs__panel">
            {activeTab.layout ? <GeneratePage {...activeTab.layout} /> : activeTab.children}
          </div>
        )}
      </div>
    </div>
  );
}
